<template>
  <div>
    <el-dialog
      v-if="visible"
      :visible="visible"
      :title="title || defauleTitle"
      show-close
      top="5vh"
      :width="width"
      :close-on-click-modal="false"
      :before-close="() => close()"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-alert type="warning" show-icon :closable="false">
        <span slot="title">
          该发货单下部分产品库存不足,可以选择<b class="color">新建入库单</b
          >增加库存
        </span>
      </el-alert>

      <Main
        ref="main"
        :loading="loading"
        :tableData="tableData"
        @change="(e) => $emit('change', e)"
      >
        <div slot="header">
          <div class="d-flex mt-2">
            <div class="side-frame-success"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                {{
                  $l('table_label_out_stock_product_details') || '缺货产品明细'
                }}
              </span>
            </div>
          </div>
        </div>
      </Main>
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" class="ml-2" @click="confirm()">
          {{ $l('btn_add_warehousing_order') || '新建入库单' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    scmCode: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    defauleTitle: {
      type: String,
      default: '出库产品缺货',
    },
    width: { type: String, default: '60%' },
    confirmOnClose: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    tableHeight: { type: Number, default: 500 },
    method: { type: String, default: 'POST' },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return { loading: false }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    async confirm() {
      this.$emit('confirm', await this.$refs.main.getTableData())
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
